// extracted by mini-css-extract-plugin
export var slate = "BristolSkyline-module--slate--zEn0Y";
export var darkCloud = "BristolSkyline-module--darkCloud--JKUaC";
export var homeSkyline = "BristolSkyline-module--homeSkyline--OavzS";
export var homeSkylineShadow = "BristolSkyline-module--homeSkylineShadow--Of2k9";